<template>
  <header id="mainHeader" class="">
    <div class="columns">
      <div class="column">
        <div id="logoContainer">
          <img :src="logoUrl" alt="">
          <!-- <h4>{{ client }}</h4> -->
        </div>
      </div>
      <div class="column">
        <nav id="desktopNav">
          <ul class="content">
            <router-link tag="button" :class="{ 'router-link-exact-active': $route.name === 'create' }" :to="{ name: 'create' }" replace>Abrir Empresa</router-link>
            <router-link tag="button" :class="{ 'router-link-exact-active': $route.name === 'transfer' }" :to="{ name: 'transfer' }" replace>Transferir Empresa</router-link>
          </ul>
        </nav>
      </div>
    </div>
    <nav id="mobileNav">
      <transition name="slideDown">
      <ul v-if="mobileOpen">
        <router-link tag="h5" :to="{ name: 'create' }" replace>Abrir Empresa</router-link>
        <router-link tag="h5" :to="{ name: 'transfer' }" replace>Transferir Empresa</router-link>
      </ul>
      </transition>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
export default{
  name: 'mainHeader',
  data () {
    return {
      mobileOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'client'
    ]),
    logoUrl () {
      return this.$api('logomarca')
    }
  },
  components: {
  }
}
</script>
